import { combineReducers } from "redux";
import log from "./log";
import auth from './auth';
import dealer from './dealer';

export default combineReducers({ log, auth, dealer });
